export default {
    'Purchase': 'Purchase',
    'CompleteRegistration': 'CompleteRegistration',
    'Lead': 'Lead',
}